import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { GetMeterModelFilesArg, GetMeterModelFilesResult } from '../../../lib/services';

export const useMeterModelFiles = (
  arg: GetMeterModelFilesArg,
  options?: UseQueryOptions<GetMeterModelFilesResult, Error>,
): UseQueryResult<GetMeterModelFilesResult> => {
  const { meterModelsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModels.files(arg.modelId, arg),
    queryFn: async ({ signal }) =>
      await meterModelsApiClient.getFiles({
        ...arg,
        signal,
      }),
    // 10 minutes
    staleTime: 10 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    ...options,
  });
};
